
import { EtsyProduct } from '@/hooks/useEtsyProducts';
import { EtsyOrder } from '@/types/etsy';

export interface OrderMetrics {
  salesCount: number;
  refundCount: number;
  cancelledCount: number;
}

export const calculateOrderMetricsForProduct = (
  product: EtsyProduct, 
  orders: EtsyOrder[]
): OrderMetrics => {
  // Filter orders that match this product (case-insensitive)
  const matchingOrders = orders.filter(order => {
    const productNameLower = order.productName.toLowerCase();
    const titleLower = product.title.toLowerCase();
    
    // Check for exact match or if one contains the other
    return productNameLower === titleLower || 
           productNameLower.includes(titleLower) || 
           titleLower.includes(productNameLower);
  });
  
  // Count orders by status - using correct status values for sales calculation
  const salesCount = matchingOrders.filter(order => 
    order.status === 'Shipped' || order.status === 'Delivered' || order.status === 'Completed'
  ).length;
  const refundCount = matchingOrders.filter(order => order.status === 'Returned').length;
  const cancelledCount = matchingOrders.filter(order => order.status === 'Cancelled').length;
  
  return {
    salesCount,
    refundCount,
    cancelledCount
  };
};

export const calculateOrderMetricsForProducts = (
  products: EtsyProduct[], 
  orders: EtsyOrder[]
): EtsyProduct[] => {
  return products.map(product => {
    const metrics = calculateOrderMetricsForProduct(product, orders);
    return {
      ...product,
      ...metrics
    };
  });
};
